export default __webpack_public_path__ + "static/media/WhatsApp Image 2021-11-07 at 8.55.44 PM.13f1e195.jpeg";